import React from "react";
import { connect } from "react-redux";
import helpersNumbers from "../../../helpers/numbers";

function AccountBalance({ score, wallet }) {
  return (
    <div className="px-2 ">
      <div className="d-flex">
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : موجودی </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(wallet)
            )}
          </span>
          <span>تومان</span>
        </div>
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : Hicoin </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(score)
            )}
          </span>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    score: state.main.score,
    wallet: state.main.wallet,
  };
};

export default connect(mapStateToProps, null)(AccountBalance);
